import _ from 'lodash'
import { saveUser } from '../../utils/localStorage'

export const addToSlip = (
  data,
  set,
  id,
  marketIndex,
  buttonIndex,
  sport,
  competition,
  marketTitle,
  name,
  odds,
  slug,
  date,
  start
) => {
  // 1. Take a copy
  const betslip = { ...data.betslip }
  // 2. Add the bet details to the betslip
  betslip[`${id}-${marketIndex}-${buttonIndex}`] = {
    id,
    marketIndex,
    buttonIndex,
    sport,
    competition,
    marketTitle,
    name,
    odds,
    slug,
    date,
    start,
  }
  // 3.Update state object
  set({ betslip })
  console.log(betslip)
}

export const removeFromSlip = (data, set, id, marketIndex, buttonIndex) => {
  // 1. Take a copy
  const betslip = { ...data.betslip }
  // 2. Remove item from betslip
  delete betslip[`${id}-${marketIndex}-${buttonIndex}`]
  // 3. Update state object
  set({ betslip })
}

export const removeAllFromSlip = set => {
  // 1. Set the betslip to an empty object
  const betslip = {}
  set({ betslip })
}

export const updateOrder = (
  data,
  set,
  id,
  marketIndex,
  buttonIndex,
  odds,
  stake
) => {
  // 1. Take a copy
  const betslip = { ...data.betslip }
  // 2. Add the bet details to the betslip
  betslip[`${id}-${marketIndex}-${buttonIndex}`].stake = parseFloat(stake)
  betslip[`${id}-${marketIndex}-${buttonIndex}`].returns =
    parseFloat(stake) * odds
  // 3.Update state object
  set({ betslip })
}

export const updateUserBalance = (data, set, stake) => {
  // 1. Take a copy
  const user = { ...data.user }
  // 2. Update the balance
  user.balance -= stake
  // 3. Update state object
  set({ user })
  // 4. Save the updated user into local storage
  saveUser(user)
}

export const addToBetHistory = (bets, data, set, multiBets, setMultiBets) => {
  // add it to user.history
  const user = { ...data.user }
  const { history } = data.user
  // We'll need to add something unique so that the same
  // bet can be added.
  const timeStamp = Date.now()
  // We'll add a readable date format to the history object
  const timeBetPlaced = new Date(timeStamp).toLocaleString()

  // Lets's grab a copy of the betslip
  const betslip = { ...data.betslip }

  // We'll need to keep some bets so we can
  // reinstate the betslip
  const keepBets = {}

  // If the user has no history lets prep an empty array
  // const history = user.history || []

  // map through the bets and check if there is a valid stake
  bets.map(key => {
    const bet = data.betslip[key]
    // 1. Skip any bet cards that don't have a stake
    if (!bet.stake) {
      return
    }

    // 2. Add the bet details to history - append the time to the end
    // so that we can have duplicate bets in history.
    // Add the time to the history object
    history[`${bet.id}-${bet.marketIndex}-${bet.buttonIndex}-${timeStamp}`] = {
      ...bet,
      timeBetPlaced,
      betKey: `${bet.id}-${bet.marketIndex}-${bet.buttonIndex}-${timeStamp}`,
    }

    // 3. Lets keep the valid bets in case we need to reinstate the betslip
    keepBets[`${bet.id}-${bet.marketIndex}-${bet.buttonIndex}`] = {
      ...bet,
    }

    // 4. Let's now remove the valid bets from the betslip as we go
    delete betslip[`${bet.id}-${bet.marketIndex}-${bet.buttonIndex}`]
  })

  // Let's add any multi bets via the multibets hook passed to this function
  if (!_.isEmpty(multiBets.straight)) {
    history[`${multiBets.straight.title}-${timeStamp}`] = {
      ...multiBets,
      timeBetPlaced,
      betKey: `${multiBets.straight.title}-${timeStamp}`,
    }
  }

  // Update the user and betslip objects in state
  set({ history: user.history })
  set({ betslip })

  // Let's reset the multiBet state
  setMultiBets({
    ...multiBets,
    straight: {},
  })

  // return the successful bets that were placed so we can reinstate the
  // the betslip if required
  return keepBets
}

// Generate a random number as a bet placement receipt
export const getReceiptNumber = () => {
  const min = Math.ceil(1000000)
  const max = Math.floor(1999999)
  return Math.floor(Math.random() * (max - min)) + min
}

// Returns a multi name based on the leg count
export const displayLegs = count => {
  if (count === 2) {
    return 'Double'
  }
  if (count === 3) {
    return 'Triple'
  }
  return `${count} Leg Multi`
}
